import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import {AppClipsComponent} from './app-clips/app-clips/app-clips.component';
import {NewAppClipsComponent} from './new-app-clips/new-app-clips.component';


const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent
  },
  {
    path: 'building/:id',
    component: AppClipsComponent,
    pathMatch: 'full'
  },
  {
    path: ':buildingName',
    component: NewAppClipsComponent,
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
